import { useMutation, useQueryClient } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import formsApi from '../api/forms.api';
import { CreateFieldValue } from '../types/formFields/forms';
import * as DisplayStrings from '../displayStrings';
import { AxiosError } from 'axios';
import { extractMessageFromError } from '../utils/errorUtils';
import { useEventFormParams } from './useEventFormParams';
import { useNavigate } from 'react-router-dom';

export const useEventFormUpdate = () => {
  const { eventId, stepId, formId } = useEventFormParams();
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(
    (values: CreateFieldValue[]) => formsApi.updateFormValues(companyId, eventId, stepId, formId, values),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['formDetails', formId]);
        showToast({
          title: DisplayStrings.FormUpdateSuccessTitle,
          description: DisplayStrings.FormUpdateSuccessMessage,
          status: 'success',
          'data-cy': 'qe-form-update-success-toast',
        });
        navigate(`/events/${eventId}/steps/${stepId}/forms/${formId}`);
      },
      onError: (e: AxiosError) => {
        showToast({
          title: DisplayStrings.FormUpdateFailedTitle,
          description: extractMessageFromError(e),
          status: 'error',
        });
      },
    },
  );
};
